import {
  FAQS,
  AnalyticsHeader,
  PRE_PURCHASE_FAQS,
  TERMS_AND_CONDITION_ADD_ON,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const sanantoniospurs_pass: TTeamConfig = {
  TEAM_SCHEMA: "sanantoniospurs_pass",
  TEAM_FULL_NAME: "San Antonio Spurs",
  BROWSER_TITLE: "San Antonio Spurscription",
  CLIENT_ID: "f8bb7bfe9c46.seasonshare.spurs-spurs.us",

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202024-25/light-bg/sas-removebg.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202024-25/spurs-v3-assets/Coyote%20Texas%20Spurs%20Flag.png",
    FOOTER_LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202024-25/dark-bg/sas.png",
  },

  LANGUAGES: {
    FAQS,
    PRE_PURCHASE_FAQS,
    TERMS_AND_CONDITION_ADD_ON,
  },

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#000000",
    DEFAULT_APP_ROUTE: routes.home,
    LOGOUT_ON_INVALID_SESSION: true,
    IS_INTERCOM_ENABLED: true,
    ANALYTICS_HEADER: AnalyticsHeader,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      ADD_SERVICE_FEE_TO_PRICE: true,
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,
  },

  HOME_PAGE_SETTINGS: {
    HIDE_EVENT_BANNER: false,

    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#8a8d8f",
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },

    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    SUBSCRIPTION_DETAILS: {
      HIDE_RESUME_SUBSCRIPTION_BUTTON: false,
    },
    ZERO_STATE: {
      NO_UPCOMING_RENEWAL_PERIOD_MESSAGE:
        "This is the end of your pass for this season. Please check back later to purchase for next season.",
    },
  },
};
